import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateTime } from 'luxon';
import {
  HealthCheckNotification,
  HealthCheckNotificationSeverityLevel,
} from '@shared/models/health-check-notifications';
import { UserService } from '../../../auth/user.service';
import { BasicRole } from '@shared/userRoles';
import { MatIconModule } from '@angular/material/icon';
import { NbButtonModule, NbTooltipModule, NbIconModule } from '@nebular/theme';
import { NgClass } from '@angular/common';

@Component({
  selector: 'implto-health-check-message',
  templateUrl: './health-check-message.component.html',
  styleUrls: ['./health-check-message.component.scss'],
  imports: [NgClass, NbButtonModule, NbTooltipModule, NbIconModule, MatIconModule],
})
export class HealthCheckMessageComponent {
  @Input()
  message?: HealthCheckNotification;

  @Input()
  read = false;

  @Output()
  markAsRead = new EventEmitter<boolean>();

  @Output()
  deleted = new EventEmitter<HealthCheckNotification>();

  isDeleteBtnVisible = false;

  constructor(private user: UserService) {
    // TODO @Ruslan Does just admin can hide it?
    this.isDeleteBtnVisible = this.user.hasRole(BasicRole.admin);
  }

  get date(): string {
    const dateStr = this.message?.createdAt || '';
    if (dateStr.length > 0) {
      const date = DateTime.fromISO(dateStr);
      return date.toLocaleString(DateTime.DATETIME_MED);
    }
    return '';
  }

  get icon(): string {
    switch (this.message?.severityLevel) {
      case HealthCheckNotificationSeverityLevel.INFO:
        return 'info';
      case HealthCheckNotificationSeverityLevel.SUCCESS:
        return 'check_circle';
      case HealthCheckNotificationSeverityLevel.WARNING:
        return 'error_outlined';
      case HealthCheckNotificationSeverityLevel.ERROR:
        return 'error_outlined';
      case HealthCheckNotificationSeverityLevel.CRITICAL:
        return 'dangerous';
    }
  }

  get iconColor(): string {
    switch (this.message?.severityLevel) {
      case HealthCheckNotificationSeverityLevel.INFO:
        return '#0095ff';
      case HealthCheckNotificationSeverityLevel.SUCCESS:
        return '#00d68f';
      case HealthCheckNotificationSeverityLevel.WARNING:
        return '#ffaa00';
      case HealthCheckNotificationSeverityLevel.ERROR:
        return '#ff3d71';
      case HealthCheckNotificationSeverityLevel.CRITICAL:
        return '#ff3d3d';
      default:
        return '#5b9fbc';
    }
  }

  get backgroundColor(): string {
    if (this.read) {
      return '#a5a5a522';
    }
    return `${this.iconColor}22`;
  }

  get borderColor(): string {
    if (this.read) {
      return 'transparent';
    }
    return this.iconColor;
  }

  toggleReadStatus(): void {
    this.markAsRead.emit(!this.read);
  }

  onDelete(): void {
    this.deleted.emit(this.message);
  }
}
